import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

export const useButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: "160px",
    },
  })
);
